import { render, staticRenderFns } from "./CustomPushNotifications.vue?vue&type=template&id=3665cc87&"
import script from "./CustomPushNotifications.vue?vue&type=script&lang=js&"
export * from "./CustomPushNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CustomPushNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports